import axios from 'axios';

const BASE = `${process.env.REACT_APP_API_URL ?? 'http://localhost:8000/api/v1'}/hero-sliders`;

const authHeader = (token: string) => ({ Authorization: `Bearer ${token}` });

export const heroSliderService = {
    fetchPublic: (audience: string) =>
        axios.get(`${BASE}/public`, { params: { audience } }),

    fetchAll: (token: string, page = 1, limit = 10, status?: string, sortBy = 'bannerOrder', sortOrder: 'asc' | 'desc' = 'asc') =>
        axios.get(BASE, {
            params: { page, limit, sortBy, sortOrder, ...(status && status !== 'all' ? { status } : {}) },
            headers: authHeader(token),
        }),

    fetchById: (token: string, id: string) =>
        axios.get(`${BASE}/${id}`, { headers: authHeader(token) }),

    create: (token: string, formData: FormData) =>
        axios.post(BASE, formData, { headers: authHeader(token) }),

    update: (token: string, id: string, formData: FormData) =>
        axios.put(`${BASE}/${id}`, formData, { headers: authHeader(token) }),

    toggleStatus: (token: string, id: string, status: string) =>
        axios.patch(`${BASE}/${id}/status`, { status }, { headers: authHeader(token) }),

    reorder: (token: string, items: { id: string; bannerOrder: number }[]) =>
        axios.patch(`${BASE}/reorder`, { items }, { headers: authHeader(token) }),

    trackClick: (id: string) =>
        axios.post(`${BASE}/${id}/track-click`),

    delete: (token: string, id: string) =>
        axios.delete(`${BASE}/${id}`, { headers: authHeader(token) }),
};
